module.exports = require('./helpers/bundle-url').getBundleURL('gK5mg') + "check-mark-green.9c2ca868.svg";